import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import {useTranslation} from 'react-i18next';

const MAX_STATEMENT_LENGTH = 2000;

// Modal de fusión/supersesión MANUAL (decisión 5 del plan: dedup a mano en v1). Se elige
// cuál de los hechos seleccionados queda (el "superviviente", editable) y los demás pasan a
// superseded por él (se desactivan, salen del contexto). No se borra info: queda la cadena.
// `modalClassName` es opcional y no cambia nada por default: existe porque el modal se portalea
// a `<body>` y desde el Recorrido tiene que poder vestirse con la paleta del Booster sin que eso
// alcance a la Memoria clásica, que lo monta igual y sigue siendo blanca (QA-VIS-dup-01).
export function FactMergeModal({isOpen, facts, saving, toggle, onMerge, modalClassName}) {
    const {t} = useTranslation();
    const [survivorId, setSurvivorId] = useState(null);
    const [statement, setStatement] = useState('');

    // Firma estable del set (ids), NO la referencia del array: el padre re-crea `facts` en
    // cada render, así que depender de `facts` resetearía el survivor/edición en cada render.
    // Con la firma, sólo se re-inicializa al abrir el modal o si cambia la selección.
    const factIdsKey = (facts || []).map((f) => f.id).join(',');
    useEffect(() => {
        if (isOpen && facts && facts.length) {
            setSurvivorId(facts[0].id);
            setStatement(facts[0].statement || '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen, factIdsKey]);

    const selectSurvivor = (fact) => {
        setSurvivorId(fact.id);
        setStatement(fact.statement || '');
    };

    const enough = !!facts && facts.length >= 2;
    const trimmed = statement.trim();
    const valid = enough && !!survivorId && trimmed.length > 0 && trimmed.length <= MAX_STATEMENT_LENGTH;

    return (
        <Modal isOpen={isOpen} toggle={toggle} modalClassName={modalClassName}>
            <ModalHeader toggle={toggle}>{t('client_memory.merge_modal.title')}</ModalHeader>
            <ModalBody>
                <div className="modal-section">
                    {!enough ? (
                        <p className="cmem-merge-help">{t('client_memory.merge_modal.need_two')}</p>
                    ) : (
                        <>
                            <p className="cmem-merge-help">{t('client_memory.merge_modal.help')}</p>
                            <div className="cmem-merge-options">
                                {facts.map((fact) => (
                                    <label key={fact.id}
                                           className={`cmem-merge-option ${fact.id === survivorId ? '-survivor' : ''}`}>
                                        <input type="radio" name="cmem-survivor"
                                               checked={fact.id === survivorId}
                                               onChange={() => selectSurvivor(fact)}/>
                                        <span>{fact.statement}</span>
                                    </label>
                                ))}
                            </div>
                            <div className="form-row">
                                <label>{t('client_memory.merge_modal.final_label')}</label>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={statement}
                                    maxLength={MAX_STATEMENT_LENGTH}
                                    onChange={(e) => setStatement(e.target.value)}
                                />
                            </div>
                        </>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={saving}>
                    {t('client_memory.action.cancel')}
                </Button>
                <button type="button" className="btn -alt" disabled={!valid || saving}
                        onClick={() => onMerge(survivorId, trimmed)}>
                    {t('client_memory.merge_modal.confirm')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
